var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31661 0.947266C2.67475 0.947266 2.05918 1.18714 1.60532 1.61412C1.15146 2.0411 0.896484 2.62021 0.896484 3.22405V14.608C0.896484 15.2118 1.15146 15.7909 1.60532 16.2179C2.05918 16.6449 2.67475 16.8847 3.31661 16.8847H15.4172C16.0591 16.8847 16.6746 16.6449 17.1285 16.2179C17.5824 15.7909 17.8373 15.2118 17.8373 14.608V3.22405C17.8373 2.62021 17.5824 2.0411 17.1285 1.61412C16.6746 1.18714 16.0591 0.947266 15.4172 0.947266H3.31661ZM4.65009 5.83893C5.0336 5.83893 5.4014 5.69561 5.67258 5.44049C5.94377 5.18537 6.09611 4.83935 6.09611 4.47856C6.09611 4.11776 5.94377 3.77174 5.67258 3.51662C5.4014 3.2615 5.0336 3.11818 4.65009 3.11818C4.26658 3.11818 3.89878 3.2615 3.6276 3.51662C3.35642 3.77174 3.20407 4.11776 3.20407 4.47856C3.20407 4.83935 3.35642 5.18537 3.6276 5.44049C3.89878 5.69561 4.26658 5.83893 4.65009 5.83893ZM5.86015 14.3951V6.9056H3.44003V14.3951H5.86015ZM7.46711 6.9056H9.88723V7.90853C10.2442 7.38259 11.0283 6.67451 12.4864 6.67451C14.2265 6.67451 15.1716 7.7594 15.1716 9.8233C15.1716 9.92234 15.1812 10.3743 15.1812 10.3743V14.3939H12.7611V10.3754C12.7611 9.8233 12.6377 8.73841 11.3333 8.73841C10.0276 8.73841 9.91749 10.1022 9.88723 10.9947V14.3939H7.46711V6.9056Z",
    fill: "#DDDBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.57570d330e6a4333a02c34b162aad951.svg";
export { ForwardRef as ReactComponent };